module.exports = __webpack_public_path__ + "img/special-2.74c47a77.png";